import { useEffect, useState } from "react";
import DebounceSearchInput from "../../../components/Tables/DebounceSearchInput";
import { SearchIcon } from "../../../components/common/Icons";
import Button from "../../../components/common/Button";
import { NumberDropdownList } from "../../../components/common/DropdownList";
import { ColumnFiltersState, PaginationState, SortingState } from "@tanstack/react-table";
import ServiceSectionTable from "./LatestNewsTable";
import { baseObj } from "../../../utils/constants";
import { templateList } from "../../../active-time-report/views/ActiveTimeReport";
import LatestNews, { ILabelValueData, LatestNewsType } from "../LatestNews";
import { useGetMediaInfoMutation, useGetMediaListQuery } from "../../../app/services/services/media";
import { endpointUrl, renderDateFormatDMY, renderDateFormatYMD } from "../../../app/services/api";
import axios from "../../../axios";
import { ToastContainer, toast } from "react-toastify";
import { useGetMediaCategoryListQuery } from "../../../app/services/services/mediaCategory";
import CommonErrorPopup from "../../../components/common/CommonErrorPopup";
import { getAuthUser } from "../../../app/services/dashboard";
const LatestNewsSectionList = () => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 20
  });
  const [isLayoutControlOpen, setIsLayoutControlOpen] = useState<boolean>(
    false
  );
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  //let [localModuleId, setLocalModuleId] = useState<number>(0);
  const [data, setData] = useState<baseObj[]>([]);
  const [itemCount, setItemCount] = useState<number>(0);
  const [tempList, setTempList] = useState<any>(templateList);
  const [hiddenFields, setHiddenFields] = useState<string[]>([]);
  const [globalSearch, setGlobalSearch] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [viewCols, setCols] = useState<any>([]);
  const [showList, setShowList] = useState<boolean>(true);
  const [errorPopup, setErrorPopup] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [isSave, setIsSave] = useState<boolean>(false);
  const [servicesData, setServicesData] = useState<LatestNewsType>({
    id: 0,
    meta_title_en: "",
    meta_title_tc: "",
    meta_title_sc: "",
    meta_description_en: "",
    meta_description_tc: "",
    meta_description_sc: "",
    meta_image: "",
    category_id: "",
    media_category:null,
    title_en: "",
    title_sc: "",
    title_tc: "",
    description_en: "",
    description_sc: "",
    description_tc: "",
    image: undefined,
    image_url: "",
    image_list: undefined,
    image_url_list: [
      "https://satshkphase2.visibleone.pro/_next/image?url=https%3A%2F%2Fs3-alpha-sig.figma.com%2Fimg%2F755d%2F6a4c%2Ff85d0e655df354d97e9a0aab41912aec%3FExpires%3D1734307200%26Key-Pair-Id%3DAPKAQ4GOSFWCVNEHN3O4%26Signature%3DMUwItnCMMcw0KPXYtAO6FsC9uY2Qa2oj2RPweDEiaRQnroL-b77LqtgDdd8rFbrvx-Q9DQ0geXPjlYBrgzuNqVmqf1594c6kevG9T74pyy9AgZK1H4U5ei3YaKIjpMvqpyuKcHSYbhxShCE3lw1vIJmOdGb9Bh~FlG0GKJjIbRH0S-HCrIfvaUmc0Y6oR~ZLJ-x0jSLe0WAlmU~8R5ZWyw4UfvAIptwRKQr41NYEGsynTmlYhp2PQoStekD4nuFaIhZdbyuvbkVvj0vWMXQVcM-3nONhngB98gKxUSAVxy0IQUmsLLTCZuNOPy5JSlNiltPkp-ehqH21tlZR0oTAvA__&w=1080&q=75",
      "https://fakeimg.pl/200x100"
    ],
    upload_date:undefined
  });
  const [categoryList,setCategoryList]=useState<ILabelValueData[]>([]);
  const [getMediaInfo] = useGetMediaInfoMutation();
  const [sorting, setSorting] = useState<SortingState>([]);
  const { data: medias } = useGetMediaListQuery({
    page: currentPage,
    limit: pagination.pageSize,
    search: globalSearch,
    type: 'latest-news',
    sort: sorting?sorting.map((s) => `${s.desc ? '-' : ''}${s.id}`).join(','):'',
  })
  const { data: categories } = useGetMediaCategoryListQuery({
    page: 1,
    limit: pagination.pageSize,
    search: '',
    type: 'latest-news',
    sort:''
  });
  useEffect(()=>{
    if(categories){
      if(categories?.data){
        setCategoryList(categories?.data?.map((x:any)=>{
          return {
            value:x.id,
            label:x.title_en
          }
        }));
      }
    }
  },[categories]);
  useEffect(() => {
    if (medias) {
      setData(medias.data);
      setItemCount(medias.total);      
    }
  }, [medias]);
  const handle_submit = async (data:LatestNewsType, imageFiles: File[],metaImageFile:File|undefined) => {
    setIsSave(true);
    const formData = new FormData();
    formData.append('meta_title_en', data?.meta_title_en ?? '');
    formData.append('meta_title_tc', data?.meta_title_tc ?? '');
    formData.append('meta_title_sc', data?.meta_title_sc ?? '');
    formData.append('meta_description_en', data?.meta_description_en ?? '');
    formData.append('meta_description_tc', data?.meta_description_tc ?? '');
    formData.append('meta_description_sc', data?.meta_description_sc ?? '');
    if (metaImageFile) {
      formData.append('meta_image', metaImageFile);
    }
    formData.append('id', data?.id?.toString() ?? '');
    formData.append('title_en', data?.title_en ?? '');
    formData.append('title_tc', data?.title_tc ?? '');
    formData.append('title_sc', data?.title_sc ?? '');
    formData.append('description_en', data?.description_en ?? '');
    formData.append('description_tc', data?.description_tc ?? '');
    formData.append('description_sc', data?.description_sc ?? '');
    formData.append('category_id', data?.category_id ?? '');
    formData.append('page_type', 'latest-news');
    formData.set('upload_date', data.upload_date ? renderDateFormatYMD(new Date(data.upload_date), '-') : '');
    if (data.image) {
      formData.append('image', data.image as any);
    }
    const url=data.id?'update-media-content':'media-content';
    var getUser = getAuthUser();
    await axios(endpointUrl + url, {
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getUser.token}`,
      },
      data: formData,
    })
      .then((res: any) => {
        if (res?.data?.status === true) {
          setShowList(true);
          getMediaInfo({
            page: currentPage,
            limit: pagination.pageSize,
            search: '',
            sort:'',
            type: 'latest-news',
          }).then((res: any) => {
            setData(res?.data?.data);
            setItemCount(res?.data?.total)
          })
          toast(res?.data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        } else {
          setErrorPopup(true);
          setMessage(res?.data?.message);
        }
        setIsSave(false);
      })
      .catch((err) => {
        setIsSave(false);
        setErrorPopup(true);
        setMessage(Object.values(err?.response?.data?.errors)?.join(' '));
      });
  }
  const clear_data = () => {
    setServicesData({
      id: 0,
      meta_title_en: "",
      meta_title_tc: "",
      meta_title_sc: "",
      meta_description_en: "",
      meta_description_tc: "",
      meta_description_sc: "",
      meta_image: "",
      category_id: "",
      media_category:null,
      title_en: "",
      title_sc: "",
      title_tc: "",
      description_en: "",
      description_sc: "",
      description_tc: "",
      image: undefined,
      image_url: "",
      image_list: undefined,
      image_url_list: [
        "https://satshkphase2.visibleone.pro/_next/image?url=https%3A%2F%2Fs3-alpha-sig.figma.com%2Fimg%2F755d%2F6a4c%2Ff85d0e655df354d97e9a0aab41912aec%3FExpires%3D1734307200%26Key-Pair-Id%3DAPKAQ4GOSFWCVNEHN3O4%26Signature%3DMUwItnCMMcw0KPXYtAO6FsC9uY2Qa2oj2RPweDEiaRQnroL-b77LqtgDdd8rFbrvx-Q9DQ0geXPjlYBrgzuNqVmqf1594c6kevG9T74pyy9AgZK1H4U5ei3YaKIjpMvqpyuKcHSYbhxShCE3lw1vIJmOdGb9Bh~FlG0GKJjIbRH0S-HCrIfvaUmc0Y6oR~ZLJ-x0jSLe0WAlmU~8R5ZWyw4UfvAIptwRKQr41NYEGsynTmlYhp2PQoStekD4nuFaIhZdbyuvbkVvj0vWMXQVcM-3nONhngB98gKxUSAVxy0IQUmsLLTCZuNOPy5JSlNiltPkp-ehqH21tlZR0oTAvA__&w=1080&q=75",
        "https://fakeimg.pl/200x100"
      ],
      upload_date:undefined
    })
  }
  return (
    <div className="bg-white text-left rounded-xl pt-4 pb-4 sm:pt-4 sm:pb-9 px-4 w-full h-full font-primary">
       <ToastContainer className={"text-12 font-poppins font-normal"} />
        <CommonErrorPopup
            show={errorPopup}
            setShow={setErrorPopup}
            message={message}
        />
      {showList === false ? <div>
        <LatestNews
          handle_submit={handle_submit}
          isSave={isSave}
          initialData={servicesData}
          setValue={setServicesData}
          setShowList={setShowList}
          categoryList={categoryList}
          
        />
      </div> : <>
        <div className="flex flex-wrap justify-between items-center mb-1">
          <div className="flex items-center mr-2 xs:mr-4 sm:w-[260px] w-[225px] my-1">
            <DebounceSearchInput setState={setGlobalSearch} debounce={800}>
              {setState =>
                <div className="flex border-1 border-[#C4C4C4] bg-white hover:bg-[#EFEFEF] rounded-[28px]">
                  <input
                    type="text"
                    placeholder="Search"
                    className="focus:outline-none py-1 px-4 text-12 xl:text-14 leading-5 bg-transparent rounded-[28px] w-full text-graydark"
                    onChange={e => setState(e.target.value)}
                  />
                  <SearchIcon className="mr-2" />
                </div>}
            </DebounceSearchInput>
          </div>

          <div className="flex items-center xs:mt-1 sm:mt-1">
            <Button
              label="+ Add New"
              onClick={() => { clear_data(); setShowList(false) }}
              type="button"
              variant="primary"
              customClass="py-[3px] my-1 px-2 focus:outline-none hover:bg-vorpmyanmar hover:border-vorpmyanmar hover:text-vorpblue 2xl:text-[14px] text-12 leading-5 font-medium text-white"
              size="base"
            />
          </div>
        </div>

        <div className="flex sm:flex-row flex-col justify-end mb-1">
          <div className="flex items-center sm:justify-start justify-end">
            <div className="flex items-center 3xl:ml-3 mr-[10px]">
              <p className="xl:text-sm text-12 mr-2 text-black2 font-primary">
                DISPLAY
              </p>
              <NumberDropdownList
                state={pagination.pageSize}
                setState={value =>
                  setPagination(prev => ({
                    ...prev,
                    pageSize: value as number
                  }))}
                dropdownItems={new Array(5).fill(1).map((_, index: number) => {
                  const count = (index + 1) * 20;
                  return {
                    value: count,
                    label: String(count)
                  };
                })}
                className="max-w-[55px] 4xs:max-w-[60px] lg:max-w-[72px]"
                textAlign="text-left pl-3"
                paddingClass="py-[2px]"
                placeholder="All"
              />
            </div>
          </div>
        </div>

        <div>
          <div className="text-left">
            <ServiceSectionTable
              // columnsData={columnsData}
              isLayoutControlOpen={isLayoutControlOpen}
              setIsLayoutControlOpen={setIsLayoutControlOpen}
              globalSearch={globalSearch}
              setGlobalSearch={setGlobalSearch}
              columnFilters={columnFilters}
              setColumnFilters={setColumnFilters}
              pagination={pagination}
              data={data}
              setData={setData}
              setPagination={setPagination}
              hiddenFields={hiddenFields ? hiddenFields : []}
              setHiddenFields={setHiddenFields}
              checkManagement={true}
              total={itemCount}
              localModuleId={1}
              // visArray={visArray}
              //templateList={tempList}
              setCurrentView={() => 1}
              setCols={setCols}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              sorting={sorting}
              setSorting={setSorting}
              setServicesData={setServicesData}
              setShowList={setShowList}
              setItemCount={setItemCount}
            />
          </div>
        </div>
      </>}
    </div>
  );
};
export default LatestNewsSectionList;
